import React, { useEffect } from 'react';
import './App.css';
import { FokusMarker } from './lib/fokus';
// Self-hosted fonts (no requests to Google) — replaces fonts.googleapis.com
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/cormorant-garamond/300.css';
import '@fontsource/cormorant-garamond/400.css';
import '@fontsource/cormorant-garamond/500.css';
import '@fontsource/cormorant-garamond/600.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/playfair-display/500.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/cormorant-garamond/700.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate, useParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Hero from './components/Hero';
import SpecialAreas from './components/SpecialAreas';
import Vision from './components/Vision';
import { Welcome, Services } from './components/WelcomeAndServices';
import Partners from './components/Partners';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials';
import Awards from './components/Awards';
import NewsTeaser from './components/NewsTeaser';
import Seo from './components/Seo';
import { OrganizationSchema } from './components/StructuredData';
import CookieConsent from './components/CookieConsent';
import GoogleAnalytics from './components/GoogleAnalytics';
import { EmailTypoHint } from './components/EmailTypoHint';
import ScrollToTop from './components/ScrollToTop';
import PlausibleAnalytics from './components/PlausibleAnalytics';
import { ChatWidget, BackToTop } from './components/ChatAndUtils';
import Jobs from './pages/Jobs';
import Mandantenerfassung from './pages/Mandantenerfassung';
import Sepa from './pages/Sepa';
import EinbuergerungsSelbsttest from './pages/EinbuergerungsSelbsttest';
import RechtsgebietPage from './pages/RechtsgebietPage';
import Team from './pages/Team';
import Login from './pages/Login';
import Register from './pages/Register';
import PasswortVergessen from './pages/PasswortVergessen';
import PasswortZurueckSetzen from './pages/PasswortZurueckSetzen';
import Dashboard from './pages/Dashboard';
import Dokumente from './pages/Dokumente';
import DokumentScan from './pages/DokumentScan';
import Downloads from './pages/Downloads';
import Profil from './pages/Profil';
import Admin from './pages/Admin';
import AuthCallback from './pages/AuthCallback';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import AGB from './pages/AGB';
import Aktuelles from './pages/Aktuelles';
import KanzleiPostfach from './pages/KanzleiPostfach';
import MeineNachrichten from './pages/MeineNachrichten';
import TeamRueckrufe from './pages/TeamRueckrufe';
import TeamTickets from './pages/TeamTickets';
import KanzleiPlaner from './pages/KanzleiPlaner';
import KanzleiKalender from './pages/KanzleiKalender';
import KanzleiOutlook from './pages/KanzleiOutlook';
import KanzleiForderungen from './pages/KanzleiForderungen';
import KanzleiSepa from './pages/KanzleiSepa';
import KanzleiAbgleich from './pages/KanzleiAbgleich';
import AdminSchnittstellen, { AdminZeitstrahl } from './pages/AdminSchnittstellen';
import AdminZahlungsuebersicht from './pages/AdminZahlungsuebersicht';
import KanzleiEingang from './pages/KanzleiEingang';
import { GlobalSuche } from './components/kanzlei/GlobalSuche';
import { KanzleiLeiste, useKanzleiLeisteSichtbar, hatUnterleiste } from './components/kanzlei/KanzleiLeiste';
import { GlobaleAblage } from './components/kanzlei/GlobaleAblage';
import { TerminWidget } from './components/kanzlei/TerminWidget';
import KanzleiSupport from './pages/KanzleiSupport';
import { Arbeitsflaeche, flaecheFuer } from './components/kanzlei/Arbeitsflaeche';
import { TippSystem } from './components/hilfe/Tipp';
import PortalZustimmung from './pages/PortalZustimmung';
import KanzleiZahlungen from './pages/KanzleiZahlungen';
import KanzleiWebsiteAktuelles from './pages/KanzleiWebsiteAktuelles';
import AdminBereich from './pages/AdminBereich';
import MeineArbeitszeit from './pages/MeineArbeitszeit';
import Urlaubsplan from './pages/Urlaubsplan';
import PortalTermine from './pages/PortalTermine';
import KanzleiRechnungen from './pages/KanzleiRechnungen';
import KanzleiBenutzer from './pages/KanzleiBenutzer';
import { PortalDock, usePortalDockSichtbar } from './components/portal/PortalDock';
import { PortalAblage } from './components/portal/PortalAblage';
import { DateiFelderDrop } from './components/upload/DateiFelderDrop';
import { PortalansichtBanner } from './components/portal/Portalansicht';
import { ArbeitszeitTracker } from './hooks/useArbeitszeit';
import PortalAkten from './pages/PortalAkten';
import PortalZahlungen from './pages/PortalZahlungen';
import PortalAngaben from './pages/PortalAngaben';
import KanzleiAkte from './pages/KanzleiAkte';
import Kontaktverzeichnis from './pages/Kontaktverzeichnis';
import KanzleiFristen from './pages/KanzleiFristen';
import AdminBewerbungen from './pages/AdminBewerbungen';
import AdminNotfall from './pages/AdminNotfall';
import AdminZahlungen from './pages/AdminZahlungen';
import Notfallkontakt from './pages/Notfallkontakt';
import Honorarrechner from './pages/Honorarrechner';
import Rueckruf from './pages/Rueckruf';
import Ratenzahlung from './pages/Ratenzahlung';
import RatenzahlungInfo from './pages/RatenzahlungInfo';
import Akontozahlung from './pages/Akontozahlung';
import AkontoAngebot from './pages/AkontoAngebot';
import AdminAkonto from './pages/AdminAkonto';
import AdminRechtstexte from './pages/AdminRechtstexte';
import MagicLinkLogin from './pages/MagicLinkLogin';
import { RechtstexteGate } from './components/RechtstexteGate';
import Mandanten360 from './pages/Mandanten360';
import AdminMandatsunterlagen from './pages/AdminMandatsunterlagen';
import SignaturenUebersicht from './pages/SignaturenUebersicht';
import Signatur from './pages/Signatur';
import MeineRaten from './pages/MeineRaten';
import NotfallZugang from './pages/NotfallZugang';
import { FeatureGate } from './hooks/useFeatures';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';
import { CobrowseClient } from './components/cobrowse/CobrowseClient';
import KanzleiCobrowse from './pages/KanzleiCobrowse';
import KanzleiPortalansicht from './pages/KanzleiPortalansicht';
import KanzleiVorlagen from './pages/KanzleiVorlagen';
import KanzleiTermin from './pages/KanzleiTermin';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Rechtsanwalt & Steuerberater Bonn | Kanzlei Nabhan Gäbler & Partner"
        description="Rechtsanwälte & Steuerberater in Bonn – bundesweit tätig. Ausländerrecht, Einbürgerung, Steuerrecht, Strafrecht & Gesellschaftsrecht. Persönlich, mehrsprachig, 100 % digital. Erstberatung 200 €."
        path="/"
        keywords="Rechtsanwalt Bonn, Steuerberater Bonn, Anwalt Bonn, Kanzlei Bonn, Anwalt Ausländerrecht, Anwalt Einbürgerung, Steuerkanzlei Bonn, Strafverteidiger Bonn"
      />
      <OrganizationSchema />
      <Header />
      <main>
        <Hero />
        <SpecialAreas />
        <Vision />
        <Welcome />
        <Services />
        <NewsTeaser />
        <Partners />
        <Testimonials />
        <Awards />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
      <BackToTop />
      <Toaster />
    </div>
  );
};

// Umbauvorgabe O: alte Adressen leiten auf den Kanzlei-Bereich um
const ADMIN_TABS = { anfragen: '/kanzlei/eingang/anfragen', rueckrufe: '/team/rueckrufe', termine: '/kanzlei/termine', raten: '/kanzlei/zahlungen/raten', users: '/kanzlei/konten', docs: '/kanzlei/dokumente', newsletter: '/kanzlei/website/newsletter', sepa: '/kanzlei/zahlungen' };
const AdminEinstieg = () => {
  const { search } = useLocation();
  const p = new URLSearchParams(search);
  const tab = p.get('tab');
  p.delete('tab');
  if (tab === 'sepa') p.set('filter', 'sepa');
  const rest = p.toString() ? `?${p}` : '';
  return <Navigate to={tab ? `${ADMIN_TABS[tab] || '/kanzlei/eingang'}${rest}` : '/admin/analyse'} replace />;
};
const Weiter = ({ to }) => {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
};
const NachMandant = () => {
  const { mandantenNr } = useParams();
  return <Navigate to={`/kanzlei/nachrichten?chat=general_${mandantenNr}`} replace />;
};
const ZurAkte = () => {
  const { mandantenNr } = useParams();
  return <Navigate to={`/kanzlei/mandanten/${mandantenNr}`} replace />;
};
const ZumPostfach = () => {
  const { caseId } = useParams();
  return <Navigate to={`/kanzlei/nachrichten?chat=${caseId}`} replace />;
};
const DashboardEinstieg = () => {
  const { user } = useAuth();
  return ['admin', 'kanzlei_mitarbeiter', 'freelancer'].includes(user?.role) ? <Navigate to="/kanzlei/eingang" replace /> : <Dashboard />;
};

// Router with session_id handling
const AppRouter = () => {
  const location = useLocation();
  const leiste = useKanzleiLeisteSichtbar();
  const dock = usePortalDockSichtbar();
  const oeffentlich = !leiste && !dock && !/^\/(admin|kanzlei|team-portal|team\/|login|register)/.test(location.pathname);
  const auth = /^\/(login|register|passwort|magic)/.test(location.pathname);
  useEffect(() => {
    const b = document.body.classList;
    b.add('lf');
    b.toggle('lf-public', oeffentlich);
    b.toggle('lf-auth', auth);
    b.toggle('lf-intern', !oeffentlich && !auth);
    b.toggle('lf-kanzlei', leiste);
  }, [oeffentlich, auth, leiste]);
  // Detect session_id during render (NOT useEffect) to prevent race conditions
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
    <GlobalSuche />
    <CobrowseClient />
    <KanzleiLeiste />
    <GlobaleAblage />
    <TerminWidget />
    <TippSystem />
    <PortalDock />
    <PortalAblage />
    <DateiFelderDrop />
    <PortalansichtBanner />
    <ArbeitszeitTracker />
    <FokusMarker />
    <div className={leiste ? `kp-inhalt${flaecheFuer(location.pathname) ? ' mit-flaeche' : ''}` : dock ? 'pb-24' : undefined} style={leiste ? { paddingTop: `calc(${hatUnterleiste(location.pathname) ? 96 : 56}px + var(--kp-hinweis, 0px))` } : undefined}>
    {leiste && <Arbeitsflaeche />}
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/karriere" element={<Jobs />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/mandantenerfassung" element={<Mandantenerfassung />} />
      <Route path="/sepa-lastschrift" element={<ProtectedRoute hinweis><Sepa /></ProtectedRoute>} />
      <Route path="/honorarrechner" element={<Honorarrechner />} />
      <Route path="/rueckruf" element={<ProtectedRoute hinweis><Rueckruf /></ProtectedRoute>} />
      <Route path="/ratenzahlung" element={<ProtectedRoute hinweis><RatenzahlungInfo /></ProtectedRoute>} />
      <Route path="/akontozahlung" element={<ProtectedRoute hinweis><Akontozahlung /></ProtectedRoute>} />
      <Route path="/akontozahlung/:akontoId" element={<ProtectedRoute><AkontoAngebot /></ProtectedRoute>} />
      <Route path="/kanzlei/mandanten" element={<ProtectedRoute adminOnly={true}><Mandanten360 /></ProtectedRoute>} />
      <Route path="/kanzlei/mandanten/:mandantenNr" element={<ProtectedRoute adminOnly={true}><Mandanten360 /></ProtectedRoute>} />
      <Route path="/kanzlei/konten" element={<ProtectedRoute adminOnly={true}><Admin festerTab="users" /></ProtectedRoute>} />
      <Route path="/kanzlei/dokumente" element={<ProtectedRoute adminOnly={true}><Admin festerTab="docs" /></ProtectedRoute>} />
      <Route path="/kanzlei/mandatsunterlagen" element={<ProtectedRoute adminOnly={true}><AdminMandatsunterlagen /></ProtectedRoute>} />
      <Route path="/kanzlei/signaturen" element={<ProtectedRoute adminOnly={true}><SignaturenUebersicht /></ProtectedRoute>} />
      <Route path="/kanzlei/termine" element={<ProtectedRoute adminOnly={true}><Admin festerTab="termine" /></ProtectedRoute>} />
      <Route path="/kanzlei/eingang/anfragen" element={<ProtectedRoute adminOnly={true}><Admin festerTab="anfragen" /></ProtectedRoute>} />
      <Route path="/kanzlei/zahlungen/raten" element={<ProtectedRoute adminOnly={true}><Admin festerTab="raten" /></ProtectedRoute>} />
      <Route path="/portal/termine" element={<ProtectedRoute><PortalTermine /></ProtectedRoute>} />
      <Route path="/kanzlei/zahlungen/rechnungen" element={<ProtectedRoute adminOnly={true}><KanzleiRechnungen /></ProtectedRoute>} />
      <Route path="/kanzlei/zahlungen/akonto" element={<ProtectedRoute adminOnly={true}><AdminAkonto /></ProtectedRoute>} />
      <Route path="/kanzlei/rueckrufe/notfall" element={<FeatureGate flag="notfall"><ProtectedRoute adminOnly={true}><AdminNotfall /></ProtectedRoute></FeatureGate>} />
      <Route path="/admin/analyse" element={<ProtectedRoute><AdminBereich bereich="analyse" /></ProtectedRoute>} />
      <Route path="/admin/einstellungen" element={<ProtectedRoute><AdminBereich bereich="einstellungen" /></ProtectedRoute>} />
      <Route path="/admin/akten" element={<ProtectedRoute><AdminBereich bereich="akten" /></ProtectedRoute>} />
      <Route path="/admin/arbeitszeit" element={<ProtectedRoute><AdminBereich bereich="arbeitszeit" /></ProtectedRoute>} />
      <Route path="/kanzlei/arbeitszeit" element={<ProtectedRoute><MeineArbeitszeit /></ProtectedRoute>} />
      <Route path="/kanzlei/profil" element={<ProtectedRoute><Profil /></ProtectedRoute>} />
      <Route path="/kanzlei/urlaub" element={<ProtectedRoute><Urlaubsplan /></ProtectedRoute>} />
      <Route path="/admin/mandanten" element={<Navigate to="/kanzlei/mandanten" replace />} />
      <Route path="/admin/mandanten/:mandantenNr" element={<ZurAkte />} />
      <Route path="/admin/akonto" element={<Weiter to="/kanzlei/zahlungen/akonto" />} />
      <Route path="/admin/rechtstexte" element={<Navigate to="/kanzlei/website/rechtstexte" replace />} />
      <Route path="/kanzlei/website" element={<Navigate to="/kanzlei/website/aktuelles" replace />} />
      <Route path="/kanzlei/website/aktuelles" element={<ProtectedRoute adminOnly={true}><KanzleiWebsiteAktuelles /></ProtectedRoute>} />
      <Route path="/kanzlei/website/newsletter" element={<ProtectedRoute adminOnly={true}><Admin festerTab="newsletter" /></ProtectedRoute>} />
      <Route path="/kanzlei/website/bewerbungen" element={<ProtectedRoute adminOnly={true}><AdminBewerbungen /></ProtectedRoute>} />
      <Route path="/kanzlei/website/rechtstexte" element={<ProtectedRoute adminOnly={true}><AdminRechtstexte /></ProtectedRoute>} />
      <Route path="/kanzlei/support/bestaetigungen" element={<ProtectedRoute adminOnly={true}><AdminRechtstexte /></ProtectedRoute>} />
      <Route path="/kanzlei/support" element={<ProtectedRoute adminOnly={true}><KanzleiSupport /></ProtectedRoute>} />
      <Route path="/kanzlei/zahlungen" element={<ProtectedRoute adminOnly={true}><KanzleiZahlungen /></ProtectedRoute>} />
      <Route path="/kanzlei/zahlungen/notfall" element={<FeatureGate flag="notfall"><ProtectedRoute adminOnly={true}><AdminZahlungen /></ProtectedRoute></FeatureGate>} />
      <Route path="/admin/mandatsunterlagen" element={<Weiter to="/kanzlei/mandatsunterlagen" />} />
      <Route path="/signatur/:vorgangId" element={<Signatur />} />
      <Route path="/ratenzahlung/:planId" element={<ProtectedRoute><Ratenzahlung /></ProtectedRoute>} />
      <Route path="/portal" element={<Navigate to="/dashboard" replace />} />
      <Route path="/portal/akten" element={<ProtectedRoute><PortalAkten /></ProtectedRoute>} />
      <Route path="/portal/akten/:caseId" element={<ProtectedRoute><PortalAkten /></ProtectedRoute>} />
      <Route path="/portal/zustimmung/:zid" element={<ProtectedRoute><PortalZustimmung /></ProtectedRoute>} />
      <Route path="/portal/zahlungen" element={<ProtectedRoute><PortalZahlungen /></ProtectedRoute>} />
      <Route path="/portal/angaben/:id" element={<ProtectedRoute><PortalAngaben /></ProtectedRoute>} />
      <Route path="/meine-raten" element={<ProtectedRoute><MeineRaten /></ProtectedRoute>} />
      <Route path="/notfallkontakt" element={<FeatureGate flag="notfall"><Notfallkontakt /></FeatureGate>} />
      <Route path="/notfallkontakt/zugang" element={<FeatureGate flag="notfall"><NotfallZugang /></FeatureGate>} />
      <Route path="/admin/notfallkontakte" element={<Weiter to="/kanzlei/rueckrufe/notfall" />} />
      <Route path="/admin/zahlungen" element={<Navigate to="/kanzlei/zahlungen" replace />} />
      <Route path="/einbuergerungs-selbsttest" element={<EinbuergerungsSelbsttest />} />
      <Route path="/rechtsgebiete/:slug" element={<RechtsgebietPage />} />
      <Route path="/rechtsgebiete" element={<Navigate to="/" replace />} />
      <Route path="/kontakt" element={<Navigate to="/#kontakt" replace />} />
      <Route path="/team" element={<Team />} />
      <Route path="/aktuelles" element={<Aktuelles />} />
      <Route path="/team-portal" element={<Navigate to="/kanzlei/eingang" replace />} />
      <Route path="/team-portal/m/:mandantenNr" element={<NachMandant />} />
      <Route path="/team-portal/:caseId" element={<ZumPostfach />} />
      <Route path="/kanzlei/akten/:caseId" element={<ProtectedRoute><KanzleiAkte /></ProtectedRoute>} />
      <Route path="/kanzlei/kontakte" element={<ProtectedRoute><Kontaktverzeichnis /></ProtectedRoute>} />
      <Route path="/kanzlei/fristen" element={<ProtectedRoute adminOnly={true}><KanzleiFristen /></ProtectedRoute>} />
      <Route path="/kanzlei/nachrichten" element={<ProtectedRoute><KanzleiPostfach /></ProtectedRoute>} />
      <Route path="/meine-akten" element={<ProtectedRoute><MeineNachrichten /></ProtectedRoute>} />
      <Route path="/meine-akten/:caseId" element={<ProtectedRoute><MeineNachrichten /></ProtectedRoute>} />
      <Route path="/admin/team" element={<Navigate to="/kanzlei/benutzer" replace />} />
      <Route path="/kanzlei/benutzer" element={<ProtectedRoute><KanzleiBenutzer /></ProtectedRoute>} />
      <Route path="/team/rueckrufe" element={<ProtectedRoute><TeamRueckrufe /></ProtectedRoute>} />
      <Route path="/team/tickets" element={<ProtectedRoute><TeamTickets /></ProtectedRoute>} />
      <Route path="/kanzlei/planer" element={<ProtectedRoute><KanzleiPlaner /></ProtectedRoute>} />
      <Route path="/kanzlei/kalender" element={<ProtectedRoute adminOnly={true}><KanzleiKalender /></ProtectedRoute>} />
      <Route path="/kanzlei/portalansicht" element={<ProtectedRoute adminOnly={true}><KanzleiPortalansicht /></ProtectedRoute>} />
      <Route path="/kanzlei/vorlagen" element={<ProtectedRoute adminOnly={true}><KanzleiVorlagen /></ProtectedRoute>} />
      <Route path="/kanzlei/termin/:nid" element={<ProtectedRoute adminOnly={true}><KanzleiTermin /></ProtectedRoute>} />
      <Route path="/kanzlei/outlook" element={<ProtectedRoute adminOnly={true}><KanzleiOutlook /></ProtectedRoute>} />
      <Route path="/kanzlei/zahlungen/mahnlauf" element={<ProtectedRoute adminOnly={true}><KanzleiForderungen /></ProtectedRoute>} />
      <Route path="/kanzlei/zahlungen/sepa-lastschrift" element={<ProtectedRoute adminOnly={true}><KanzleiSepa /></ProtectedRoute>} />
      <Route path="/kanzlei/zahlungen/abgleich" element={<ProtectedRoute adminOnly={true}><KanzleiAbgleich /></ProtectedRoute>} />
      <Route path="/admin/schnittstellen" element={<ProtectedRoute><AdminSchnittstellen /></ProtectedRoute>} />
      <Route path="/admin/zahlungsuebersicht" element={<ProtectedRoute adminOnly={true}><AdminZahlungsuebersicht /></ProtectedRoute>} />
      <Route path="/admin/zeitstrahl" element={<ProtectedRoute><AdminZeitstrahl /></ProtectedRoute>} />
      <Route path="/kanzlei" element={<Navigate to="/kanzlei/eingang" replace />} />
      <Route path="/kanzlei/einstellungen" element={<Navigate to="/admin/einstellungen" replace />} />
      <Route path="/kanzlei/cobrowsing" element={<ProtectedRoute adminOnly={true}><KanzleiCobrowse /></ProtectedRoute>} />
      <Route path="/kanzlei/eingang" element={<ProtectedRoute><KanzleiEingang /></ProtectedRoute>} />
      <Route path="/admin/bewerbungen" element={<Navigate to="/kanzlei/website/bewerbungen" replace />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/datenschutz" element={<Datenschutz />} />
      <Route path="/agb" element={<AGB />} />
      <Route path="/login" element={<Login />} />
      <Route path="/anmelden/link" element={<MagicLinkLogin />} />
      <Route path="/register" element={<Register />} />
      <Route path="/passwort-vergessen" element={<PasswortVergessen />} />
      <Route path="/passwort-zuruecksetzen" element={<PasswortZurueckSetzen />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardEinstieg /></ProtectedRoute>} />
      <Route path="/dokumente" element={<ProtectedRoute><Dokumente /></ProtectedRoute>} />
      <Route path="/dokumente/scannen" element={<ProtectedRoute><DokumentScan /></ProtectedRoute>} />
      <Route path="/downloads" element={<Downloads />} />
      <Route path="/profil" element={<ProtectedRoute><Profil /></ProtectedRoute>} />
      <Route path="/admin" element={<AdminEinstieg />} />
      <Route path="/admin/uploads" element={<Navigate to="/kanzlei/dokumente" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    </div>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AppRouter />
            <RechtstexteGate />
            <CookieConsent />
            <EmailTypoHint />
            <GoogleAnalytics />
            <PlausibleAnalytics />
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
